/* eslint-disable @typescript-eslint/no-explicit-any */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TipoImpuestoModeloType } from "api/Types/TipoImpuestosModelosEnum"
import { TRIMESTRE_ENUM, TrimestreEnumType } from "api/Types/TrimestreEnum"
// eslint-disable-next-line import/no-cycle
import { ButtonERP, OptionsMenuStorybook } from "@finanedi.es/storybook"
import {
  faArrowLeft,
  faCheck,
  faEye,
  faFileExcel,
  faPen,
  faPlus,
} from "@fortawesome/pro-light-svg-icons"
import { AlbaranReadingSimpleDtoProps } from "api/DTOs/AlbaranReadingSimpleDto"
import { EnumReadinDtoProps } from "api/DTOs/EnumReadinDto"
import { FacturaReadingSimpleDtoProps } from "api/DTOs/FacturaReadingSimpleDto"
import { GetModelo180DetalleImpuestosDto } from "api/DTOs/GetModelo180DetalleImpuestosDto"
import { GetModelo190DetalleImpuestosDto } from "api/DTOs/GetModelo190DetalleImpuestosDto"
import { GetModelo347DetalleImpuestosDto } from "api/DTOs/GetModelo347DetalleImpuestosDto"
import { GetModeloDetalleImpuestosAsientosContablesDtoBaseProps } from "api/DTOs/GetModeloDetalleImpuestosAsientosContablesDtoBase"
import { PedidoReadingSimpleDtoProps } from "api/DTOs/PedidoReadingSimpleDto"
import { PeriodoGetModelo303DtoProps } from "api/DTOs/PeriodoGetModelo303Dto"
import { PeriodoGetModelo390DtoProps } from "api/DTOs/PeriodoGetModelo390Dto"
import { PresupuestoReadingSimpleDtoProps } from "api/DTOs/PresupuestoReadingSimpleDto"
import { DATE_DD_MM_YYYY } from "common/components/FilterMenu/constants"
import { formatCurrency, formatNumber } from "common/utils/currency"
import { formatDate } from "common/utils/date"
import { TFunction } from "i18next"
import { Tooltip } from "primereact/tooltip"
import { Dispatch, SetStateAction } from "react"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"
import {
  MODELO_IMPUESTO,
  ModeloImpuestoType,
} from "../../../../../../api/Types/ModeloImpuesto"
import * as ROUTES from "../../../../../../routes/RoutePaths"
import { MODELOS_IMPUESTOS } from "../../constants/modelosImpuestos"
import { TEXTO_TRIMESTRE } from "../../constants/textoTrimestre"
import { RedirectParams } from "../constants"
import { periodOfDays } from "./periodOfDaysTrimester"

export type TypesIvaTemplate = {
  0: string
  1: string
}

interface DateRange {
  min: string
  max: string
}

export const TYPES_IVA = (t: TFunction): TypesIvaTemplate => {
  return {
    0: `${t("taxSummary.detail.supported")}`,
    1: `${t("taxSummary.detail.charged")}`,
  }
}

export const obtenerTotales = (data: $TSMigrationFixMe, key: string) => {
  return formatNumber(
    data
      .reduce((total: $TSMigrationFixMe, item: $TSMigrationFixMe) => {
        const valor =
          parseFloat(item[key].replace(/[^\d,]/g, "").replace(",", ".")) || 0
        return total + valor
      }, 0)
      .toFixed(2)
  )
}

export const TIPOS_RESUMENES_IVA = {
  soportado: 0,
  repercutido: 1,
}

export const propertiesToCheck = [
  "baseImponibleRepercutido",
  "baseImponibleSoportado",
  "ivaRepercutido",
  "ivaSoportado",
  "totalIva",
]
export const obtenerFechaFinTrimestre = (
  trimestre: TrimestreEnumType | null,
  year: string
): string => {
  const trimestresValidos: TrimestreEnumType[] = [
    TRIMESTRE_ENUM.PRIMER_TRIMESTRE,
    TRIMESTRE_ENUM.SEGUNDO_TRIMESTRE,
    TRIMESTRE_ENUM.TERCER_TRIMESTRE,
    TRIMESTRE_ENUM.CUARTO_TRIMESTRE,
  ]
  if (!trimestre) {
    return ""
  }
  if (trimestre && !trimestresValidos.includes(trimestre)) {
    throw new Error("Trimestre no válido")
  }
  const mesesPorTrimestre: { [key in TrimestreEnumType]: number } = {
    [TRIMESTRE_ENUM.PRIMER_TRIMESTRE]: 3,
    [TRIMESTRE_ENUM.SEGUNDO_TRIMESTRE]: 6,
    [TRIMESTRE_ENUM.TERCER_TRIMESTRE]: 9,
    [TRIMESTRE_ENUM.CUARTO_TRIMESTRE]: 12,
  }
  const ultimoDia = new Date(`${year}-${mesesPorTrimestre[trimestre]}-01`)
  ultimoDia.setMonth(ultimoDia.getMonth() + 1)
  ultimoDia.setDate(ultimoDia.getDate() - 1)
  return formatDate(ultimoDia, DATE_DD_MM_YYYY)
}
export const IVA_IMPUESTOS_COLUMNS = (
  t: TFunction,
  navigate: ({ route, periodo, tipo, modelo, year }: RedirectParams) => void,
  selectedYear: $TSMigrationFixMe,
  setShowModalAsiento: Dispatch<
    SetStateAction<{
      showConfirm: boolean
      showAsiento: boolean
      data: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps | null
    }>
  >,
  isModelo390: boolean,
  isLoadingConfirm: TrimestreEnumType | boolean,
  requestHandleDownloadXml: (periodo?: TrimestreEnumType) => void,
  goToDeclaracionModelo: (
    rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
  ) => void
) => {
  const columns = [
    {
      header: `${t("taxSummary.tables.period")}`,
      key: "periodo",
      field: "periodo",
      style: { width: "10%" },
      className: "!tw-py-3 !tw-pl-10 !tw-pr-2",
      body: ({
        periodo,
      }: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps) =>
        periodo ? TEXTO_TRIMESTRE(t)[periodo] : "Total",
    },
    {
      header: `${t("taxSummary.tables.baseImponibleRepercutido")}`,
      key: "repercutido.baseImponible",
      field: "repercutido.baseImponible",
      alignCol: "right",
      style: { width: "18%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (
        rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
      ) => formatCurrency(rowData?.repercutido?.baseImponible ?? 0),
    },
    {
      header: `${t("taxSummary.tables.ivaRepercutido")}`,
      key: "repercutido.iva",
      field: "repercutido.iva",
      alignCol: "right",
      style: { width: "14%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (
        rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
      ) => {
        const isRedirect = rowData?.periodo
        return (
          <span
            className={isRedirect ? "!tw-text-info hover:tw-underline" : ""}
            onClick={() =>
              isRedirect &&
              navigate({
                route: `${ROUTES.RESUMEN_IMPUESTOS}/${
                  isModelo390
                    ? MODELO_IMPUESTO.MODELO_390
                    : MODELO_IMPUESTO.MODELO_303
                }`,
                periodo: rowData?.periodo,
                modelo: isModelo390
                  ? MODELO_IMPUESTO.MODELO_390
                  : MODELO_IMPUESTO.MODELO_303,
                tipo: TIPOS_RESUMENES_IVA.repercutido,
                year: selectedYear,
              })
            }
          >
            {formatCurrency(rowData?.repercutido?.iva ?? 0)}
          </span>
        )
      },
    },
    {
      header: `${t("taxSummary.tables.baseImponible")}`,
      key: "soportado.baseImponible",
      field: "soportado.baseImponible",
      alignCol: "right",
      style: { width: "18%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (
        rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
      ) => formatCurrency(rowData?.soportado?.baseImponible ?? 0),
    },
    {
      header: `${t("taxSummary.tables.ivaSoportado")}`,
      key: "soportado.iva",
      field: "soportado.iva",
      alignCol: "right",
      style: { width: "15%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (
        rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
      ) => {
        const isRedirect = rowData?.periodo
        return (
          <span
            className={isRedirect ? "!tw-text-info hover:tw-underline" : ""}
            onClick={() =>
              isRedirect &&
              navigate({
                route: `${ROUTES.RESUMEN_IMPUESTOS}/${
                  isModelo390
                    ? MODELO_IMPUESTO.MODELO_390
                    : MODELO_IMPUESTO.MODELO_303
                }`,
                periodo: rowData?.periodo,
                modelo: isModelo390
                  ? MODELO_IMPUESTO.MODELO_390
                  : MODELO_IMPUESTO.MODELO_303,
                tipo: TIPOS_RESUMENES_IVA.soportado,
                year: selectedYear,
              })
            }
          >
            {formatCurrency(rowData?.soportado?.iva ?? 0)}
          </span>
        )
      },
    },
    {
      header: `${t("taxSummary.tables.resultadoIVA")}`,
      key: "totalIva",
      field: "totalIva",
      alignCol: "right",
      style: { width: "17%" },
      bodyClassName: "!tw-w-auto !tw-text-end",
      body: (
        rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
      ) => formatCurrency(rowData?.totalIva ?? 0),
    },
    ...(isModelo390
      ? []
      : [
          {
            key: "asientoContableLiquidacionId",
            field: "asientoContableLiquidacionId",
            header: `${t("taxSummary.tables.liquidacion")}`,
            alignCol: "right",
            style: { width: "4%" },
            bodyClassName: "!tw-w-auto !tw-flex !tw-justify-end tw-text-end",
            body: (
              rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
            ) =>
              rowData.periodo ? (
                <ButtonERP
                  customize={{
                    type: "white",
                    size: "md",
                  }}
                  loading={Boolean(isLoadingConfirm === rowData.periodo)}
                  icon={
                    <FontAwesomeIcon
                      icon={
                        rowData.asientoContableLiquidacionId ? faEye : faPlus
                      }
                    />
                  }
                  onClick={() => {
                    const tieneAsiento = !!rowData.asientoContableLiquidacionId

                    setShowModalAsiento({
                      showAsiento: tieneAsiento,
                      showConfirm: !tieneAsiento,
                      data: rowData ?? null,
                    })
                  }}
                />
              ) : null,
          },
        ]),
    {
      key: "buttonActions",
      alignCol: "right",
      header: "",
      style: { width: "4%" },
      className: "tw-text-right !tw-p-2",
      body: (
        rowData: PeriodoGetModelo390DtoProps | PeriodoGetModelo303DtoProps
      ) =>
        (isModelo390 && rowData.periodo) ||
        (!isModelo390 && !rowData?.periodo) ? null : (
          <div className='tw-w-full tw-flex tw-justify-end [&_*#dropdown-menu-total]:!-tw-top-5 [&_*#dropdown-menu-total]:!tw-right-8'>
            <OptionsMenuStorybook
              id={`${rowData?.periodo ?? "total"}`}
              items={[
                {
                  title: `${t("taxSummary.tables.declaracionButton")}`,
                  icon: faPen,
                  hasRedirect: false,
                  action: () => goToDeclaracionModelo(rowData),
                },
                {
                  title: `${t("taxSummary.tables.exportDetail")}`,
                  hasRedirect: false,
                  icon: faFileExcel,
                  action: () => {
                    requestHandleDownloadXml(rowData?.periodo)
                  },
                },
              ]}
              position='right'
            />
          </div>
        ),
    },
  ]
  return columns
}

export const dateRangesList = (
  t: TFunction,
  selectedYear: $TSMigrationFixMe
) => ({
  YEAR: {
    label: selectedYear,
    value: periodOfDays("YEAR", selectedYear),
  },
  FIRST_TRIMESTER: {
    label: t("dropdownDatesRanges.first"),
    value: periodOfDays("FIRST_TRIMESTER", selectedYear),
  },
  SECOND_TRIMESTER: {
    label: t("dropdownDatesRanges.second"),
    value: periodOfDays("SECOND_TRIMESTER", selectedYear),
  },
  THIRD_TRIMESTER: {
    label: t("dropdownDatesRanges.third"),
    value: periodOfDays("THIRD_TRIMESTER", selectedYear),
  },
  FOURTH_TRIMESTER: {
    label: t("dropdownDatesRanges.fourth"),
    value: periodOfDays("FOURTH_TRIMESTER", selectedYear),
  },
  JANUARY: {
    label: t("dropdownDatesRanges.january"),
    value: periodOfDays("JANUARY", selectedYear),
  },
  FEBRUARY: {
    label: t("dropdownDatesRanges.february"),
    value: periodOfDays("FEBRUARY", selectedYear),
  },
  MARCH: {
    label: t("dropdownDatesRanges.march"),
    value: periodOfDays("MARCH", selectedYear),
  },
  APRIL: {
    label: t("dropdownDatesRanges.april"),
    value: periodOfDays("APRIL", selectedYear),
  },
  MAY: {
    label: t("dropdownDatesRanges.may"),
    value: periodOfDays("MAY", selectedYear),
  },
  JUNE: {
    label: t("dropdownDatesRanges.june"),
    value: periodOfDays("JUNE", selectedYear),
  },
  JULY: {
    label: t("dropdownDatesRanges.july"),
    value: periodOfDays("JULY", selectedYear),
  },
  AUGUST: {
    label: t("dropdownDatesRanges.august"),
    value: periodOfDays("AUGUST", selectedYear),
  },
  SEPTEMBER: {
    label: t("dropdownDatesRanges.september"),
    value: periodOfDays("SEPTEMBER", selectedYear),
  },
  OCTOBER: {
    label: t("dropdownDatesRanges.october"),
    value: periodOfDays("OCTOBER", selectedYear),
  },
  NOVEMBER: {
    label: t("dropdownDatesRanges.november"),
    value: periodOfDays("NOVEMBER", selectedYear),
  },
  DECEMBER: {
    label: t("dropdownDatesRanges.december"),
    value: periodOfDays("DECEMBER", selectedYear),
  },
})

export const DROPDOWN_YEARS = () => {
  const today = new Date()
  const currentYear = today.getFullYear()
  const startingYear = 2021
  const years: string[] = Array.from(
    { length: currentYear - startingYear + 1 },
    (_, index) => (currentYear - index).toString()
  )
  return years
}

interface RenderHeaderProps {
  t: TFunction
  trimester?: string
  year: number
  goBack: $TSMigrationFixMe
  modelNumber: ModeloImpuestoType
  type: TipoImpuestoModeloType
}
export const renderHeader = ({
  t,
  trimester,
  year,
  goBack,
  modelNumber,
  type,
}: RenderHeaderProps) => {
  return (
    <div className='tw-flex tw-flex-row tw-text-xl tw-font-medium tw-items-center tw-gap-3'>
      <ButtonERP
        onClick={() => goBack()}
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        customize={{
          type: "transparent",
          size: "md",
        }}
      />

      <span className='tw-flex tw-flex-row'>
        <span>
          {`${MODELOS_IMPUESTOS(t)[modelNumber].detailTitle || ""} ${
            modelNumber !== MODELO_IMPUESTO.MODELO_190 &&
            modelNumber !== MODELO_IMPUESTO.MODELO_180 &&
            modelNumber !== MODELO_IMPUESTO.MODELO_347
              ? `- ${trimester}`
              : ""
          } - ${year}`}
        </span>
        {(modelNumber === MODELO_IMPUESTO.MODELO_303 ||
          modelNumber === MODELO_IMPUESTO.MODELO_390) && (
          <span className='tw-flex tw-ml-1'>
            -
            <span className='tw-text-secondary tw-mx-2 tw-flex tw-items-center'>
              {TYPES_IVA(t)[type]}
            </span>
          </span>
        )}
      </span>
    </div>
  )
}

export const FORMAT_STRING_DOCUMENT = {
  facturas: "factura",
  albaranes: "albarán",
  pedidos: "pedido",
  presupuestos: "presupuesto",
  rectificativa: "rectificativa",
}

export const dataBasicFormat = (
  selectedDocumento:
    | FacturaReadingSimpleDtoProps
    | AlbaranReadingSimpleDtoProps
    | PedidoReadingSimpleDtoProps
    | PresupuestoReadingSimpleDtoProps,
  tipoDocumento: keyof typeof FORMAT_STRING_DOCUMENT,
  t: TFunction,
  tipoRectificacionArray: EnumReadinDtoProps[] | undefined
) => {
  if (!selectedDocumento) {
    return []
  }
  const isFactura = tipoDocumento === Object.keys(FORMAT_STRING_DOCUMENT)[0]
  const facturaDocumento = isFactura
    ? (selectedDocumento as FacturaReadingSimpleDtoProps)
    : null
  const showTooltipMsg = (
    selectedDocument: FacturaReadingSimpleDtoProps,
    tipoRectificacion: string
  ) => {
    const invoiceCorrectionType =
      tipoRectificacion === FORMAT_STRING_DOCUMENT.rectificativa
        ? selectedDocument?.facturaRectificativa
        : selectedDocument?.facturaRectificada

    return (
      <div className='tw-flex tw-justify-end'>
        {invoiceCorrectionType?.motivo && (
          <Tooltip
            id={invoiceCorrectionType?.id}
            key={invoiceCorrectionType?.numero}
            target='.invoiceMsg'
            position='bottom'
          >
            <div>
              {selectedDocument.facturaRectificada?.codigoRectificativa && (
                <p>
                  {t("crear.factura.modal.tipoRectificationLabel")}{" "}
                  {
                    tipoRectificacionArray?.find(
                      (rectificacion) =>
                        rectificacion.id ===
                        selectedDocument.facturaRectificada?.codigoRectificativa
                    )?.description
                  }
                </p>
              )}
              <p>
                {t("crear.factura.modal.reason")}{" "}
                {invoiceCorrectionType?.motivo}
              </p>
            </div>
          </Tooltip>
        )}
        <p className='invoiceMsg tw-w-fit tw-cursor-pointer'>
          {invoiceCorrectionType?.numero || ""}
        </p>
      </div>
    )
  }

  const basicData = [
    [
      `${t("crear.factura.modal.numberTextAbbreviation")} ${
        FORMAT_STRING_DOCUMENT?.[tipoDocumento]
      }`,
      selectedDocumento?.serieNumero || "",
    ],
    ...(isFactura && facturaDocumento?.facturaRectificativa
      ? [
          [
            t("crear.factura.modal.headerCorrectedInvoiceLabel1"),
            showTooltipMsg(facturaDocumento, "rectificativa"),
          ],
        ]
      : []),
    ...(isFactura && facturaDocumento?.facturaRectificada
      ? [
          [
            t("crear.factura.modal.headerCorrectedInvoiceLabel2"),
            showTooltipMsg(facturaDocumento, "rectificada"),
          ],
        ]
      : []),
    [
      t("crear.factura.modal.headerCompanyName"),
      selectedDocumento?.empresa?.razonSocial || "",
    ],
  ]
  if (selectedDocumento?.fechaEmision) {
    basicData.push([
      `${t("crear.factura.modal.headerEmisionDate")}`,
      formatDate(selectedDocumento?.fechaEmision),
    ])
  }
  if (selectedDocumento?.fechaVencimiento) {
    basicData.push([
      `${t("crear.factura.modal.headerVencimientoDate")}`,

      formatDate(selectedDocumento.fechaVencimiento),
    ])
  }
  basicData.push([
    `${t("crear.factura.modal.headerImport")}`,
    `${formatNumber(selectedDocumento.importe || 0)} ${
      selectedDocumento.divisa || ""
    }`,
  ])

  return basicData
}

export const RESUMEN_IMPUESTO_DETAIL_COLUMNS = (
  t: TFunction,
  modelo: ModeloImpuestoType,
  renders: {
    handleOpenAsientoModal: (id: string) => void
    handleOpenDocumentoModal: (id: string) => void
  }
) => {
  const columns = [
    {
      header: t("taxSummary.detail.tab.seat"),
      field: "asiento.numero",
      key: "asiento.numero",
      style: { width: "5%" },
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.asiento.numero ? (
          <span
            className='tw-text-info-100 hover:tw-underline tw-cursor-pointer'
            onClick={() =>
              rowData.asiento?.id &&
              renders.handleOpenAsientoModal(rowData.asiento.id)
            }
          >
            {rowData.asiento.numero}
          </span>
        ) : (
          ""
        ),
      sortable: true,
      sortField: "asientoContable.numero",
    },
    {
      header: t("taxSummary.detail.tab.date"),
      field: "fecha",
      key: "fecha",
      style: { width: "7%" },
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.asiento.fecha
          ? frontendDateFormat(new Date(rowData.asiento.fecha))
          : "",
      sortable: true,
      sortField: "asientoContable.fecha",
    },
    {
      header: t("taxSummary.detail.tab.account"),
      field: "asiento.lineaImpuesto?.numeroCuentaContable",
      key: "asiento.lineaImpuesto?.numeroCuentaContable",
      style: { width: "9%" },
      sorter: true,
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.asiento.lineaImpuesto?.numeroCuentaContable,
      sortable: true,
      sortField: "cuentaContable.numero",
    },
    {
      header: t("taxSummary.detail.tab.document"),
      field: "factura",
      key: "factura",
      body: (
        rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps
      ) => {
        return rowData?.factura?.numero ? (
          <span
            className={
              rowData?.factura?.id
                ? "hover:tw-underline tw-text-info-100 tw-cursor-pointer"
                : ""
            }
            onClick={
              rowData?.factura?.id
                ? () =>
                    rowData.factura?.id &&
                    renders.handleOpenDocumentoModal(rowData.factura?.id)
                : undefined
            }
          >
            {rowData?.factura?.numero}
          </span>
        ) : (
          "-"
        )
      },
      style: { width: "8%" },
    },
    {
      header: t("taxSummary.detail.tab.companyName"),
      field: "razonSocial",
      key: "razonSocial",
      style: { width: "15%" },
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.factura?.empresa?.razonSocial || "-",
    },
    {
      header: t("taxSummary.detail.tab.taxID"),
      field: "nif",
      key: "nif",
      style: { width: "6%" },
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.factura?.empresa?.nif || "-",
    },
    {
      header: t("taxSummary.detail.tab.issueDate"),
      field: "asientoContable.factura.fechaEmision",
      key: "asientoContable.factura.fechaEmision",
      style: { width: "7%" },
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.factura?.fechaEmision
          ? frontendDateFormat(new Date(rowData.factura?.fechaEmision))
          : "",
      sortable: true,
      sortField: "asientoContable.factura.fechaEmision",
    },
    {
      header: t("taxSummary.detail.tab.taxableBase"),
      field: "subtotal",
      key: "subtotal",
      style: { width: "8%" },
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        frontendCurrency(rowData.asiento?.lineaImpuesto?.baseImponible ?? 0),
      sortable: true,
      sortField: "subtotal",
    },
    {
      header:
        modelo === MODELO_IMPUESTO.MODELO_303 ||
        modelo === MODELO_IMPUESTO.MODELO_390
          ? t("taxSummary.detail.tab.vat")
          : t("taxSummary.detail.tab.percentileRetention"),
      field: "porcentajeimpuesto",
      key: "porcentajeimpuesto",
      style: { width: "11%" },
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        rowData.asiento.lineaImpuesto?.nombreImpuesto
          ? `${rowData.asiento.lineaImpuesto?.nombreImpuesto}`
          : `${
              modelo === MODELO_IMPUESTO.MODELO_303 ||
              modelo === MODELO_IMPUESTO.MODELO_390
                ? t("impuestos.table.typeGroup.iva")
                : t("impuestos.table.typeGroup.withholding")
            } ${rowData.asiento?.lineaImpuesto?.porcentaje} %`,
      sortable: true,
      sortField: "porcentajeimpuesto",
    },
    {
      header:
        modelo === MODELO_IMPUESTO.MODELO_303 ||
        modelo === MODELO_IMPUESTO.MODELO_390
          ? t("taxSummary.detail.tab.taxLiability")
          : t("taxSummary.detail.tab.retentionFee"),
      field: "cuota",
      key: "cuota",
      style: { width: "8%" },
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        frontendCurrency(rowData.asiento?.lineaImpuesto?.cuota ?? 0),
      sortable: true,
      sortField: "valorimpuesto",
    },
    ...(modelo !== MODELO_IMPUESTO.MODELO_111 &&
    modelo !== MODELO_IMPUESTO.MODELO_115
      ? [
          {
            header: t("taxSummary.detail.tab.retention"),
            field: "retencion",
            key: "retencion",
            alignCol: "right",
            className: "!tw-text-end",
            style: { width: "7%" },
            body: (
              rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps
            ) =>
              rowData.factura?.retencion
                ? frontendCurrency(rowData.factura.retencion)
                : "-",
            sortable: true,
            sortField: "retencion",
          },
        ]
      : []),
    {
      header: t("taxSummary.detail.tab.totalInvoice"),
      field: "importe",
      key: "importe",
      style: { width: "9%" },
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModeloDetalleImpuestosAsientosContablesDtoBaseProps) =>
        frontendCurrency(rowData.factura?.importe ?? 0),
      sortable: true,
      sortField: "asientoContable.factura.importe",
    },
  ]
  return columns
}

export const RESUMEN_ANUAL_IMPUESTO_DETAIL_COLUMNS = (
  t: TFunction,
  modeloAnual: number
) => {
  const columns = [
    {
      header: t("taxSummary.detail.tab.taxID"),
      field: "nif",
      key: "nif",
      body: (
        rowData:
          | GetModelo190DetalleImpuestosDto
          | GetModelo180DetalleImpuestosDto
      ) => rowData?.nif || "-",
    },
    {
      header: t("taxSummary.detail.tab.name"),
      field: "nombre",
      key: "nombre",
      body: (
        rowData:
          | GetModelo190DetalleImpuestosDto
          | GetModelo180DetalleImpuestosDto
      ) => rowData?.nombre || "-",
    },
    {
      header: t("taxSummary.detail.tab.province"),
      field: "provincia",
      key: "provincia",
      body: (
        rowData:
          | GetModelo180DetalleImpuestosDto
          | GetModelo180DetalleImpuestosDto
      ) => rowData?.provincia || "-",
    },
    ...(modeloAnual === MODELO_IMPUESTO.MODELO_190
      ? [
          {
            header: t("taxSummary.detail.tab.key"),
            field: "key",
            key: "key",
            body: (rowData: GetModelo190DetalleImpuestosDto) =>
              rowData?.clave || "-",
          },
          {
            header: t("taxSummary.detail.tab.subKey"),
            field: "subkey",
            key: "subkey",
            body: (rowData: GetModelo190DetalleImpuestosDto) =>
              rowData?.subclave || "-",
          },
        ]
      : []),
    {
      header: t("taxSummary.detail.tab.taxableBase"),
      field: "subtotal",
      key: "subtotal",
      alignCol: "right",
      className: "!tw-text-end",
      body: (
        rowData:
          | GetModelo190DetalleImpuestosDto
          | GetModelo180DetalleImpuestosDto
      ) => frontendCurrency(rowData?.baseImponible ?? 0),
    },
    {
      header: t("taxSummary.detail.tab.totalRetention"),
      field: "importe",
      key: "importe",
      alignCol: "right",
      className: "!tw-text-end",
      body: (
        rowData:
          | GetModelo180DetalleImpuestosDto
          | GetModelo180DetalleImpuestosDto
      ) => frontendCurrency(rowData?.totalRetencion ?? 0),
    },
  ]
  return columns
}

export const RESUMEN_IMPUESTO_DETAIL_347_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      header: t("taxSummary.detail.tab.name"),
      field: "nombre",
      key: "nombre",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        rowData?.nombre || "-",
    },
    {
      header: t("taxSummary.detail.tab.taxID"),
      field: "nif",
      key: "nif",
      body: (rowData: GetModelo347DetalleImpuestosDto) => rowData?.nif || "-",
    },
    {
      header: t("taxSummary.detail.tab.key"),
      field: "key",
      key: "key",
      body: (rowData: GetModelo347DetalleImpuestosDto) => rowData?.clave || "-",
    },
    {
      header: t("taxSummary.detail.tab.isp"),
      field: "isp",
      key: "isp",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        rowData?.isp ? <FontAwesomeIcon icon={faCheck} /> : "",
    },
    {
      header: t("taxSummary.detail.tab.province"),
      field: "provincia",
      key: "provincia",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        rowData?.provincia || "-",
    },
    {
      header: t("taxSummary.detail.tab.email"),
      field: "email",
      key: "email",
      body: (rowData: GetModelo347DetalleImpuestosDto) => rowData?.email || "-",
    },
    {
      header: t("taxSummary.detail.tab.firstTrimester"),
      field: "primerTrimestre",
      key: "primerTrimestre",
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        frontendCurrency(rowData?.primerTrimestre ?? 0),
    },
    {
      header: t("taxSummary.detail.tab.secondTrimester"),
      field: "segundoTrimestre",
      key: "segundoTrimestre",
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        frontendCurrency(rowData?.segundoTrimestre ?? 0),
    },
    {
      header: t("taxSummary.detail.tab.thirdTrimester"),
      field: "tercerTrimestre",
      key: "tercerTrimestre",
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        frontendCurrency(rowData?.tercerTrimestre ?? 0),
    },
    {
      header: t("taxSummary.detail.tab.fourthTrimester"),
      field: "cuartoTrimestre",
      key: "cuartoTrimestre",
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        frontendCurrency(rowData?.cuartoTrimestre ?? 0),
    },
    {
      header: t("taxSummary.detail.tab.total"),
      field: "total",
      key: "total",
      alignCol: "right",
      className: "!tw-text-end",
      body: (rowData: GetModelo347DetalleImpuestosDto) =>
        frontendCurrency(rowData?.total ?? 0),
    },
  ]
  return columns
}

export const updateYearInDateRange = (
  year: number,
  dateRangeObject: DateRange
): DateRange => {
  const { min, max } = dateRangeObject

  const updatedMin = `${year}${min.substring(4)}`
  const updatedMax = `${year}${max.substring(4)}`

  return {
    min: updatedMin,
    max: updatedMax,
  }
}
